import React, { Component } from "react";
import { compose } from "recompose";
import moment from "moment";
import _ from "lodash";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import { SingleDatePicker } from "react-dates";
import { withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Papa from "papaparse";
import aceTheme from "../../util/aceTheme";
import http from "../../util/http";
import red from "@material-ui/core/colors/red";

const calculateColor = (value) => {
  let color = "#000";
  if (value < 0) {
    color = red[400];
  }
  return color;
};

const styles = (theme) => ({
  paper: {
    margin: "25px 0",
    padding: "10px 5px",
    minHeight: 300,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
  smallCell: { padding: "0 1px", textAlign: "center" },
});

class ReportAdjustment extends Component {
  state = {
    searchError: false,
    errorMessage: "",
    searching: false,
    clonePlayerSelectOpen: false,
    reportList: [],
    focused: false,
    focusedEnd: false,
    reportDate: moment(),
    reportEndDate: moment(),
    excludeLiveCasino: true,
    excludeDeluxeCasino: true
  };
  fnExcelReport = () => {
    const objToProcess = _.flatMap(this.state.reportList);
    const csv = Papa.unparse(objToProcess);
    const data = new Blob([csv], { type: "text/csv" });
    const csvURL = window.URL.createObjectURL(data);
    const tempLink = document.createElement("a");

    tempLink.href = csvURL;
    tempLink.setAttribute("download", "adjustment-report.csv");
    tempLink.click();
  };
  searchReport = async () => {
    try {
      const { reportDate, reportEndDate, excludeLiveCasino, excludeDeluxeCasino } = this.state;
      this.setState({ searching: true });
      const dateReport = reportDate.format("l");
      let dateEndReport = reportEndDate.format("l");
      if (reportDate.isSame(reportEndDate)) {
        dateEndReport = reportEndDate.clone().add(1, "day").format("l");
      }
      const excludeLiveCasinoReport = excludeLiveCasino ? "True" : "False";
      const excludeDeluxeCasinoReport = excludeDeluxeCasino ? "True" : "False";

      const payload = JSON.stringify({
        dateReport,
        dateEndReport,
        excludeLiveCasinoReport,
        excludeDeluxeCasinoReport
      });
      const reportAdjustmentList = await http.sendHelperCommand(
        "ReportAdjustmentHelper.aspx",
        { payload }
      );
      const reportList = _.filter(
        reportAdjustmentList.ReportAdjustmentList,
        (adjustItem) =>
          _.includes(reportAdjustmentList.ContributorList, adjustItem.IdAgent)
      );
      this.setState({ reportList, searching: false });
    } catch (err) {
      this.setState({
        searchError: true,
        errorMessage: err.message,
        searching: false,
      });
    }
  };

  handleChange = (event) => {
    this.setState({
      excludeLiveCasino: event.target.checked,
    });
  };

  handleChangeDeluxe = (event) => {
    this.setState({
      excludeDeluxeCasino: event.target.checked,
    });
  };

  render() {
    const { classes } = this.props;
    const { searching, searchError, errorMessage, reportList } = this.state;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div className={classes.container}>
          <form autoComplete="off">
            <FormControl className={classes.formControl} style={{ width: 200 }}>
              <div>Start Date</div>
              <SingleDatePicker
                isOutsideRange={() => false}
                date={this.state.reportDate}
                onDateChange={(reportDate) => this.setState({ reportDate })}
                focused={this.state.focused}
                onFocusChange={({ focused }) => this.setState({ focused })}
              />
            </FormControl>
            <FormControl className={classes.formControl} style={{ width: 200 }}>
              <div>End Date</div>
              <SingleDatePicker
                isOutsideRange={() => false}
                date={this.state.reportEndDate}
                onDateChange={(reportEndDate) =>
                  this.setState({ reportEndDate })
                }
                focused={this.state.focusedEnd}
                onFocusChange={({ focused }) =>
                  this.setState({ focusedEnd: focused })
                }
              />
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.excludeLiveCasino}
                  onChange={this.handleChange}
                />
              }
              label="Exclude Live Casino Adjustments"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.excludeDeluxeCasino}
                  onChange={this.handleChangeDeluxe}
                />
              }
              label="Exclude Deluxe Casino Adjustments"
            />
            <FormControl style={{ marginTop: 20 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={this.searchReport}
              >
                Search
              </Button>
            </FormControl>
            <FormControl style={{ marginTop: 22, marginLeft: 15 }}>
              <img
                style={{ cursor: "pointer" }}
                onClick={this.fnExcelReport}
                src="../App_Themes/Classic/images/icons/excel32.png"
              />
            </FormControl>
          </form>
          {searching && !searchError && (
            <LinearProgress className={classes.progressLinear} />
          )}
          {!searching && searchError && (
            <Paper>
              <Typography>
                Whoops, Something happened: {errorMessage}
              </Typography>
            </Paper>
          )}
          <Grid item sm>
            <Paper className={classes.paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.smallCell}>Account</TableCell>
                    <TableCell className={classes.smallCell}>Agent</TableCell>
                    <TableCell className={classes.smallCell}>
                      LastModification
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      Reference
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      TransactionType
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      Description
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      LoginName
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      PlacedDate
                    </TableCell>
                    <TableCell className={classes.smallCell}>Amount</TableCell>
                    <TableCell className={classes.smallCell}>Type</TableCell>
                  </TableRow>
                </TableHead>
                {!searching && !searchError && (
                  <TableBody>
                    {reportList.map((report) => (
                      <TableRow>
                        <TableCell className={classes.smallCell}>
                          {report.Account}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.Agent}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.LastModification}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.Reference}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.TransactionType}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.Description}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.LoginName}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.PlacedDate}
                        </TableCell>
                        <TableCell
                          className={classes.smallCell}
                          style={{
                            color: calculateColor(report.Amount),
                          }}
                        >
                          {report.Amount}
                        </TableCell>
                        <TableCell className={classes.smallCell}>
                          {report.Type}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </Paper>
          </Grid>
        </div>
      </MuiThemeProvider>
    );
  }
}

ReportAdjustment.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "ReportAdjustment",
    withTheme: true,
  })
)(ReportAdjustment);
